interface ListingSearchBarProps {
  query: string;
  onQueryChange: (query: string) => void;
}

export function ListingSearchBar({ query, onQueryChange }: ListingSearchBarProps) {
  return (
    <label className="block flex-1">
      <span className="sr-only">Search marketplace listings</span>
      <input
        className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-5 py-3 text-slate-950 placeholder:text-slate-400 focus:border-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-300"
        placeholder="Search NDC, drug, seller, lot..."
        value={query}
        onChange={event => onQueryChange(event.currentTarget.value)}
      />
    </label>
  );
}
